import { ComponentStyleConfig } from "@chakra-ui/react";

export const TagTheme: ComponentStyleConfig = {
  baseStyle: {
    container: {
      fontFamily: "body",
    },
  },
  variants: {
    brand: {
      container: {
        bg: "brand.skyblue.120",
        borderRadius: 4,
        color: "brand.darkblue.100",
        fontWeight: 500,
      },
    },
  },
};
